import React, { useState } from "react";
import {
  Button,
  Container,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import logo from "../../assets/safe.png";
import { loginUser } from "../../redux/user/UserAction";

function UserLogin() {
  // eslint-disable-next-line
  const dispatch = useDispatch();
  // eslint-disable-next-line
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line
  const [token, setToken] = useState(""); // State to store the token
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch(loginUser(email, password, navigate, setLoading));
  };

  return (
    <Container className="min-h-96 flex items-center mr-2">
      <div className="flex flex-col-reverse justify-between sm:flex-row ">
        <div className="p-1 w-full h-full">
          <div className="h-full">
            <Typography
              variant="h3"
              align="center"
              className="mb-4 text-success"
              gutterBottom
            >
              Login
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              className="mb-4 text-gray-500"
              gutterBottom
            >
              Enter your account details.
            </Typography>
            <form onSubmit={handleSubmit}>
              <FormControl fullWidth sx={{ marginBottom: 4 }}>
                <TextField
                  label="Email"
                  type="email"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mb-3"
                  required
                />
              </FormControl>

              <FormControl fullWidth sx={{ marginBottom: 1 }}>
                <TextField
                  label="Password"
                  type="password"
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mb-3"
                  required
                />
              </FormControl>
              <div className="mt-4 flex flex-row items-center justify-between mb-4">
                <Typography
                  variant="body2"
                  className="text-red-300 cursor-pointer mr-2"
                >
                  Forgot password?
                </Typography>
              </div>

              <Button
                variant="contained"
                color="primary"
                type="submit"
                className="mt-4"
                fullWidth
                onClick={handleSubmit}
                disabled={loading} // Disable the button when loading is true
              >
                {loading ? "Loading..." : "Login"}
              </Button>
            </form>
          </div>
          <div className="mt-4 flex flex-row items-center">
            <Typography variant="body2" className="text-gray-500 mr-2">
              Not registered?
            </Typography>
            <Link className="text-blue-400 ml-1" to="/signup">
              {" "}
              signup{" "}
            </Link>
          </div>
        </div>
        <div className="w-full p-1 h-full sm:mx-auto">
          <Typography variant="h3" align="center" className="mb-4 text-success">
            Welcome Back,
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            className="mb-4 text-gray-500"
          >
            Ease and Authenticate your transaction with Salama pay
          </Typography>
          <img src={logo} alt="logo" className="w-96 m-auto h-96 p-4" />
        </div>
      </div>
    </Container>
  );
}

export default UserLogin;
